"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startOfTimeSlot = void 0;
const date_fns_1 = require("date-fns");
/**
 * @summary Returns the start of the time slot for the given date.
 *
 * Returns the start of the time slot for the given date. Time slots start every 15 minutes.
 *
 * @param {number | Date} date
 * @returns {Date}
 *
 * @example
 * const start = startOfTimeSlot(dateInput);
 */
function startOfTimeSlot(date) {
    const start = (0, date_fns_1.toDate)(date);
    const currentMinutes = start.getMinutes();
    const minutes = currentMinutes - (currentMinutes % 15);
    start.setMinutes(minutes, 0, 0);
    return start;
}
exports.startOfTimeSlot = startOfTimeSlot;
